"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const convert_1 = require("../color/utilities/convert");
const transformToken = (name, token, { theme }) => [
    {
        name,
        tokenType: "shadow",
        type: "variable",
        value: token
            .map((value) => {
            const blur = ` ${value.blurRadius || 0}px`;
            const spread = ` ${value.spreadRadius || 0}px`;
            const colorRef = theme.color[value.colorToken];
            const rgb = (0, convert_1.oklchToRgb)((0, convert_1.hexToOklch)(colorRef?.hex || "#000000"));
            const rgbString = `${rgb.r}, ${rgb.g}, ${rgb.b}`;
            const color = `rgba(${rgbString}, ${value.opacity || 1})`;
            return `${value.offsetX}px ${value.offsetY}px${blur}${spread} ${color}`;
        })
            .join(", "),
    },
];
exports.default = transformToken;
